import { inject, Service } from '@angular/core';
import { CapacitorBarcodeScanner, CapacitorBarcodeScannerTypeHint } from '@capacitor/barcode-scanner';
import { CameraService } from '../camera/camera.service';

@Service()
export class ScannerService {
  private readonly cameraService = inject(CameraService);

  /**
   * Launches the barcode/QR scanner and returns the scanned value, or null when nothing is scanned.
   * Throws CameraAccessError when the camera is unavailable or permission is denied.
   */
  async scanAsync(): Promise<string | null> {
    await this.cameraService.ensureCameraReadyForScanningAsync();
    const result = await CapacitorBarcodeScanner.scanBarcode({ hint: CapacitorBarcodeScannerTypeHint.ALL });
    const value = result?.ScanResult?.trim();
    return value ? value : null;
  }
}
